import { BaseService } from './base-service';
import type { KimPushPullReport } from '@/types/KimPP';
import { KimPPReportMapper } from '@/core/mappers/kim-pp-report';
import type {
	GetKimPPCountHigherRiskFoundParamsDTO,
	GetKimPPCountHigherRiskFoundDTO,
	GetKimPPReportResponseDTO,
	GetKimPPReportRequestDTO
} from '@/core/dto/kim-pp';

export class KimPushPullReportService extends BaseService<any> {
	private static instance: KimPushPullReportService;

	private constructor(public readonly basePath: string = '/ergonomic-tool/kim-pp') {
		super();
	}

	public static getInstance(): KimPushPullReportService {
		if (!KimPushPullReportService.instance) {
			KimPushPullReportService.instance = new KimPushPullReportService();
		}
		return KimPushPullReportService.instance;
	}

	public async getCountHigherRiskFound(
		params: GetKimPPCountHigherRiskFoundParamsDTO
	): Promise<GetKimPPCountHigherRiskFoundDTO[]> {
		const url = this.basePath + `/risk/count`;
		const api = super.getInstance();
		const { data } = await api.get<GetKimPPCountHigherRiskFoundDTO[]>(url, { params });
		return data;
	}

	public async getReport(params: GetKimPPReportRequestDTO): Promise<KimPushPullReport> {
		const url = this.basePath + `/${params.file_id}`;
		const api = super.getInstance();
		const { data } = await api.get<GetKimPPReportResponseDTO>(url, { params });
		return new KimPPReportMapper(data).toDomain();
	}
}

